import React, { useMemo, useState } from "react";
import { match } from "ts-pattern";
import { useQuery } from "react-query";
import { getCompanies } from "ui-io/queries/get-companies";
import { CenterSpinner, ErrorState, NoData, useToggle, CustomCard, TitleComponent } from "ui-components";

import CompanyTableView, { CompanyT } from "./table";
// import "./styles.css";

import CompanyDetails from "../company/details";

const LatestRegisteredCompanies: React.FC = () => {
  const [currentCompany, setCurrentComapny] = useState<any>();
  const [isCompanyDetail, setToggleCompanyDetail] = useToggle(false);

  const connection = useQuery(
    getCompanies({ latestRegistered: true, pageSize: 5})
  );

  const companies: CompanyT[] = useMemo(() => {
    if (!connection?.data?.content?.length) {
      return [];
    }

    return connection.data.content.map((company: any) => {
      const latestFunding = company?.funding_rounds?.at(-1);

      const address: any =
        company?.address?.length &&
        company.address.find(
          (i: Record<string, string>) => i.type === "REGISTERED" || i.type ===  "HEADQUATER"
        );
      let directors = [];

      if (company?.management.length) {
        directors = company?.management.filter((t: Record<string, any>) => {
          return t.position.toLowerCase() === "director" || t.position.toLowerCase() === "ceo";
        });
      }
      return {
        companyID: company.companyID,
        url: company.url,
        companyName: company.name,
        industry: company?.industry?.industry,
        sicCode: company?.industry?.sic_code,
        highlights: company.tags,
        noOfDirectors: directors.length,
        location: address?.country || "",
        companyHouseNo: company.licence_no,
      };
    });
  }, [connection.data]);

  const handleCompanyDetails = (company: any) => {
    setCurrentComapny(company);
    setToggleCompanyDetail();
  };

  return (
    <div className={"w-100"}>
      <CompanyDetails
        isCompanyDetail={isCompanyDetail}
        setToggleCompanyDetail={setToggleCompanyDetail}
        currentCompany={currentCompany}
      />
      <CustomCard>
        <TitleComponent className="fs-lg ml-xs">
          Latest Registered Companies
        </TitleComponent>
        {match(connection)
          .with({ status: "loading" }, { status: "idle" }, () => (
            <CenterSpinner />
          ))
          .with({ status: "error" }, ({ error }) => (
            <ErrorState error={error} />
          ))
          .with({ status: "success" }, ({ data }) =>
            data?.length === 0 ? (
              <NoData/>
            ) : (
              <CompanyTableView
                handleCompanyDetails={handleCompanyDetails}
                companyData={companies}
                isStickyFirstColumn={false}
              />
            )
          )
          .exhaustive()}
      </CustomCard>
    </div>
  );
};

export default LatestRegisteredCompanies;
